import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';


declare const grecaptcha: any;

@Component({
  selector: 'lib-rc-recaptcha',
  template: `
<!--
<ngx-recaptcha2
    [siteKey]="recaptchaSiteKey"

    (success)="onRecaptchaResolved($event)">
  </ngx-recaptcha2> -->



`,
  styles: [``]
})


export class RcRecaptchaComponent implements OnInit {
  @Input() recaptchaSiteKey = '6LeiEYUUAAAAAOmNIBkSIUgDGec5bCRhuSwX9xwz';
  @Output() resolved: EventEmitter<string> = new EventEmitter();
  constructor() { }

  ngOnInit() {

    grecaptcha.ready(() => {
      this.resetCaptcha();
    });
  }
  public resetCaptcha() {
    grecaptcha.execute(this.recaptchaSiteKey, { action: 'login' }).then((token) => {
      this.resolved.emit(token);
    });
  }
}
